import {Button, Icon, Modal, Menu, Layout} from 'antd';
import * as React from 'react';
import HelpPage from './HelpPage';

const { Sider, Content } = Layout;

export default class HelpModal extends React.Component<any, any> {

  constructor(props: any) {
    super(props);
    this.state = {
      helpDisplay: false,
      selectedMenu: this.props.selectedMenu ? this.props.selectedMenu : "1"
    }
  }

  onHideHelp = () => {
    this.props.onHideHelp();
  };

  onMenuSelect = (e: any) => {
    this.setState({selectedMenu: e.key})
  };

  render() {
    return (

      <Modal
        title="HLRV Support"
        visible={this.props.visibility}
        width={'95vw'}
        bodyStyle={{ padding: 20 }}
        style={{ top: 10, height: '75vh' }}
        onCancel={this.onHideHelp}
        closable={false}
        footer={[
          <Button htmlType="button" key="back" onClick={this.onHideHelp}>Close</Button>
        ]}
      >
        <Layout style={{height: '75vh'}}>
          <Sider width={240} style={{ background: '#fff' }}>
            <Menu
              defaultSelectedKeys={[this.state.selectedMenu]}
              mode="vertical"
              onSelect={this.onMenuSelect}
            >
              <Menu.Item key="1">
                <Icon type="minus" />
                <span>Searching & Search Results</span>
              </Menu.Item>
              <Menu.Item key="2">
                <Icon type="minus" />
                <span>Image Viewer</span>
              </Menu.Item>
              <Menu.Item key="3">
                <Icon type="minus" />
                <span>Terms & Conditions</span>
              </Menu.Item>
            </Menu>
          </Sider>
          <Layout style={{ padding: '0 0 24px 24px' }}>
            <Content style={{overflowY: "auto", padding: '0 20px 0 0'}} >
              <HelpPage selectedMenu={this.state.selectedMenu}/>
            </Content>
          </Layout>
        </Layout>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/HelpModal.tsx